module.exports = __webpack_public_path__ + "ireland.d3255f94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/countries/ireland.png
// module id = 120
// module chunks = 0